import { type UseQueryResult, useQuery } from 'react-query';
import { RsuAwardApprovalService } from '../../services/wealthlane-award-services';

const useGetRsuApprovalAcceptance = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const rsuApprovalAcceptanceList = useQuery(
    ['getRsuApprovalAcceptanceList'],
    async () => {
      return await handleRequest(
        RsuAwardApprovalService.getApiAwardApiAppRSUAwardApprovalRSUAcceptances()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return rsuApprovalAcceptanceList;
};

export default useGetRsuApprovalAcceptance;
